export default __webpack_public_path__ + "static/media/flowersWoman.4ae7aa4f.jpg";